
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { IPagination } from '@/types';
import {
  faultList,
  deleteFault,
  deleteFaultAll,
  addFault,
  editFault,
  exportFaultType
} from '@/api/fault';
import { makeKey } from '@/utils/qiniu';
import { imageType } from '@/types/imageType';
import { limit } from '@/types/limit';
import { getQiniuToken } from '@/api/third';
import { Qiniu } from '@/types/qiniu';
import DialogSetImport from '../staff/components/setImport.vue';
import { float } from 'node_modules/html2canvas/dist/types/css/property-descriptors/float';

@Component({
  name: 'SettingTemplatePhenomenon',
  components: {
    DialogSetImport
  }
})
export default class extends Vue {
  private formSearch = {
    fault: ''
  };
  private faultOptions = [];
  private upperOptions = [
    {
      id: '1',
      name: '顶级分类'
    }
  ];

  private tableData = [];
  private dialogAddFaultVisible = false;
  private formFault: any = {
    fault_id: 0,
    upper: '',
    fault: '',
    radioIsfamiliar: '0',
    img: '',
    fullImg: '',
    ranking: 100
  };
  private action: string = 'https://up-z1.qiniup.com';
  private qiniu: any = {};
  private form: object = {};
  private dialogAddFaultSubVisible = false;
  private formAddFaultSub = {
    fault_id: '0',
    pid: '',
    fault: '',
    radioIsfamiliar: '0',
    ranking: 100
  };
  private dialogEditFaultSubVisible = false;
  private formEditFaultSub: any = {
    fault_id: '0',
    upper: '',
    fault: '',
    radioIsfamiliar: '0',
    ranking: 100
  };

  private listLoading = false;

  // 页码处理
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private rules = {
    fault: [
      {
        required: true,
        message: '请填写2-20位由数字、字母、中文组成的故障现象',
        trigger: 'blur'
      },
      {
        min: 2,
        max: 20,
        message: '请填写2-20位由数字、字母、中文组成的故障现象',
        trigger: 'blur'
      },
      {
        pattern: /[\u4e00-\u9fa5a-zA-Z0-9]/,
        message: '请填写2-20位由字母、中文组成的姓名',
        trigger: 'blur'
      }
    ]
  };

  created() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  // fault_id
  // fault_name
  // 列表获取
  private getList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      fault_name: this.formSearch.fault,
      type: 2
    };
    faultList(params)
      .then((res) => {
        const data = res.data;
        if (data) {
          this.tableData = data.list;
          if (!this.formSearch.fault) {
            this.faultOptions = data.list;
          }
          this.pagination.total = parseInt(data.count);
          this.pagination.pageSize = parseInt(data.page_size);
          this.pagination.currentPage = parseInt(data.page_current);
        } else {
          this.tableData = [];
          if (!this.formSearch.fault) {
            this.faultOptions = data.list;
          }
        }
        this.listLoading = false;
      })
      .catch((err) => {
        this.tableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 搜索
  private handleSearch() {
    this.getList();
  }

  // 清除
  private handleClear() {
    this.formSearch = {
      fault: ''
    };
    this.handleSearch();
  }

  // 页码切换
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  // 页码切换
  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  handleExport() {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      type : 2,
    };
    exportFaultType(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }


  // 批量删除
  private multipleDeleteItem = []
  private multipleDeleteInner = []
  private selectAllChange(selection: any) {
    this.multipleDeleteItem = selection;
    // 并把下级数据获取到，放到multipleDeleteItem中

    if (selection.length > 0) {
      selection.forEach((row: any) => {
        if (row.child && row.child.length > 0) {
          this.toggleSelectionInnerChange(row.child, true);
        }
      });
    } else {
      this.toggleSelectionInnerChange([], false);
    }
  }
  private selectedChange(selection: any, row: any) {
    this.multipleDeleteItem = selection;
    // 单独选择,选中的每个父级 要把子集数据也要 放到multipleDeleteItem中,去重
    let arr = selection.filter((ee:any) => {
      return row.id === ee.id;
    });
    if (arr && arr.length > 0) {
      if (this.$refs.multipleDeleteInner) {
        this.toggleSelectionInnerChange(row.child, true);
      }
    } else {
      if (this.$refs.multipleDeleteInner) {
        this.toggleSelectionInnerChange(row.child, false);
      }
    }
  }

  private selectedInnerChange(selection: any, row: any) {
    this.multipleDeleteInner = selection;
    this.multipleDeleteItem = this.multipleDeleteItem.concat(this.multipleDeleteInner);
  }
  private checkSelectable(row: any, index: any) {
    // if (this.innerFlag) {
    return true;
    // }
  }

  private toggleSelectionInnerChange(rows: any, select:boolean) {
    if (rows.length > 0) {
      rows.forEach((row: any) => {
        (this.$refs.multipleDeleteInner as any).toggleRowSelection(row, select);
      });
    } else {
      (this.$refs.multipleDeleteInner as any).clearSelection();
    }
  }

  // 添加故障现象 初始化数据
  private handelAddFault() {
    if (this.qiniu) {
      const params = {
        type: Qiniu.UPLOAD_TYPE_FAULT
      };
      getQiniuToken(params).then((res) => {
        if (res && res.data) {
          this.qiniu = res.data;
        }
      });
    }
    this.dialogAddFaultVisible = true;
    this.upperOptions = [
      {
        id: '0',
        name: '顶级分类'
      }
    ];
    this.upperOptions = this.upperOptions.concat(this.faultOptions);
    this.formFault = {
      fault_id: 0,
      upper: this.upperOptions[0],
      fault: '',
      radioIsfamiliar: '0',
      img: '',
      fullImg: '',
      ranking: 100
    };
  }

  // 添加故障现象 验证必填项
  private saveFault() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.saveFaultNet();
      } else {
        return false;
      }
    });
  }

  // 保存 故障现象
  private saveFaultNet() {
    const params : any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.formFault.upper.id,
      name: this.formFault.fault,
      is_common: this.formFault.radioIsfamiliar,
      image_save_path: this.formFault.img,
      sort: this.formFault.ranking
    };
    if (parseInt(this.formFault.fault_id) === 0) {
      this.addFault(params);
    } else {
      params.fault_id = this.formFault.fault_id;
      this.editFault(params);
    }
  }

  // 编辑故障现象
  private editHandle(val:any) {
    this.dialogAddFaultVisible = true;
    this.upperOptions = [
      {
        id: '0',
        name: '顶级分类'
      }
    ];
    this.upperOptions = this.upperOptions.concat(this.faultOptions);
    this.formFault = {
      fault_id: val.id,
      upper: this.upperOptions[0],
      fault: val.name,
      radioIsfamiliar: val.is_common,
      img: val.image_save_path,
      fullImg: val.image_real_path,
      ranking: val.sort
    };
  }
  // 编辑子类故障现象
  private editSubHandle(val:any,parent:any) {
    this.dialogEditFaultSubVisible = true;
    if(parent){
      //找到this.faultOptions里pid等于val的id人child
      let itemCurrent:any = this.faultOptions.find((item:any) => {
        return parseInt(item.id) === parseInt(parent.pid);
      });
      this.upperOptions = itemCurrent.child;
    }else{
      this.upperOptions = [
        {
          id: '0',
          name: '顶级分类'
        }
      ];
      this.upperOptions = this.upperOptions.concat(this.faultOptions);
    }
    var opp:any = '';
    for (var i = 0; i < this.upperOptions.length; i++) {
      if (this.upperOptions[i].id === val.pid) {
        opp = this.upperOptions[i];
        break;
      }
    }
    this.formEditFaultSub = {
      fault_id: val.id,
      upper: opp,
      fault: val.name,
      radioIsfamiliar: val.is_common,
      ranking: val.sort
    };
  }
  private delPL() {
    if (!this.multipleDeleteItem || this.multipleDeleteItem.length < 1) {
      this.showErrorMsg('请选择故障现象');
      return;
    }
    let id = '';
    this.multipleDeleteItem.forEach((item:any) => {
      id = id + item.id + ',';
    });
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      fault_ids: id.substring(0, id.length - 1)
    };
    deleteFaultAll(params).then(res => {
      this.showSuccessMsg('修改成功');
      this.getList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 保存 编辑子类故障现象
  private handelEditFaultSub() {
    this.dialogEditFaultSubVisible = false;
    const params : any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.formEditFaultSub.upper.id,
      name: this.formEditFaultSub.fault,
      is_common: this.formEditFaultSub.radioIsfamiliar,
      sort: this.formEditFaultSub.ranking
    };
    if (parseInt(this.formEditFaultSub.fault_id) === 0) {
      this.addFault(params);
    } else {
      params.fault_id = this.formEditFaultSub.fault_id;
      this.editFault(params);
    }
  }
  // 添加子类故障现象
  private addSubHandle(val:any) {
    this.dialogAddFaultSubVisible = true;
    this.formAddFaultSub = {
      fault_id: '0',
      pid: val.id,
      fault: '',
      radioIsfamiliar: '0',
      ranking: 100
    };
  }
  // 添加子类故障现象 保存
  private handelAddFaultSub() {
    this.dialogAddFaultSubVisible = false;
    const params : any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.formAddFaultSub.pid,
      name: this.formAddFaultSub.fault,
      is_common: this.formAddFaultSub.radioIsfamiliar,
      sort: this.formAddFaultSub.ranking
    };
    if (parseInt(this.formAddFaultSub.fault_id) === 0) {
      this.addFault(params);
    } else {
      params.fault_id = this.formAddFaultSub.fault_id;
      this.editFault(params);
    }
  }
  // 删除
  private deleteDataHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          fault_id: val.id
        };
        deleteFault(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.handleClear();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {
      });
  }
  // 添加联网
  private addFault(params :any) {
    params.type = 2;
    addFault(params)
      .then((res) => {
        this.dialogAddFaultVisible = false;
        this.showSuccessMsg('添加成功');
        this.handleClear();
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg('添加失败');
      });
  }
  // 编辑联网
  private editFault(params :any) {
    editFault(params)
      .then((res) => {
        this.dialogAddFaultVisible = false;
        this.showSuccessMsg('修改成功');
        this.handleClear();
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg('修改失败');
      });
  }
  // 导入故障现象
  private setImportVisible = false
  private setImportTitle='导入故障现象'

  private importFault() {
    this.setImportVisible = true;
  }

  closeImport(value: boolean) {
    this.getList();
    this.setImportVisible = value;
  }

  // 上传图片成功
  private handleFaultImage(val: any) {
    this.formFault.img = val.key;
    this.formFault.fullImg = (this.form as any).default_url + val.key;
  }

  // 上传图片准备
  private beforeUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M =
      file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error(
        '上传图片大小不能超过 ' + limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE + 'MB!'
      );
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain,
        default_url: this.qiniu.default_url
      };
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
